import {ISSUE_ATTRIBUTE_NAMES} from './issue-attribute-names';
import {viewTypes} from './view-types';

export const PANELS = {
  FIRST_PANEL: 'FIRST_PANEL',
  SECOND_PANEL: 'SECOND_PANEL'
};

export const ISSUES_PREVIEW_FIELD_NAMES = {
  [viewTypes.PROJECT]: {
    [PANELS.FIRST_PANEL]: [
      ISSUE_ATTRIBUTE_NAMES.ASSIGNED_TO,
      ISSUE_ATTRIBUTE_NAMES.DUE_DATE,
      ISSUE_ATTRIBUTE_NAMES.LOCATION_ID,
      ISSUE_ATTRIBUTE_NAMES.LOCATION_DETAILS
    ],
    [PANELS.SECOND_PANEL]: [
      ISSUE_ATTRIBUTE_NAMES.ISSUE_SUB_TYPE_ID,
      ISSUE_ATTRIBUTE_NAMES.OWNER_ID,
      ISSUE_ATTRIBUTE_NAMES.ROOT_CAUSE_ID
    ]
  },
  [viewTypes.DOCUMENT]: {
    [PANELS.FIRST_PANEL]: [
      ISSUE_ATTRIBUTE_NAMES.ISSUE_SUB_TYPE_ID,
      ISSUE_ATTRIBUTE_NAMES.ASSIGNED_TO,
      ISSUE_ATTRIBUTE_NAMES.DUE_DATE
    ],
    [PANELS.SECOND_PANEL]: [
      ISSUE_ATTRIBUTE_NAMES.LOCATION_ID,
      ISSUE_ATTRIBUTE_NAMES.LOCATION_DETAILS,
      ISSUE_ATTRIBUTE_NAMES.LINKED_DOCUMENTS,
      ISSUE_ATTRIBUTE_NAMES.LINKS,
      ISSUE_ATTRIBUTE_NAMES.OWNER_ID,
      ISSUE_ATTRIBUTE_NAMES.ROOT_CAUSE_ID
    ]
  }
};
